import { useSelector } from 'react-redux'

import useReduxAction from '@hooks/useReduxAction'

const useServiceGroups = (options = {}) => {
  const { performHttpRequests } = options || {}

  const entities = useSelector(reduxState => reduxState.entities)
  const { serviceGroups } = entities

  useReduxAction('serviceGroups', 'loadServiceGroups', {}, [performHttpRequests], {
    shouldPerformFn: (entityReducer) => {
      const { errors, loaded, loading } = entityReducer
      return performHttpRequests && !loaded && !loading && !errors.length
    },
  })

  return {
    serviceGroups,
  }
}

export default useServiceGroups
